const EditInsuranceApply = () => import('../modules/xmsb/energy/operators/EditInsuranceApplyGzl')

export default [
  {

    path: '/insuranceapplyedit',
    name: 'insuranceapplyedit',
    component: EditInsuranceApply,
    meta: {
      title: '申请中介服务费用补贴填写',
      fullscreen: true,
    },
  },
]
